module.exports = __webpack_public_path__ + "img/PDM-80.aef0a079.png";